import { BulkLicensesReclaimedResource, State, ready, succeeded, updating } from './Types';

import { assertNever } from '@kofno/piper';
import { Maybe, just, nothing } from 'maybeasy';
import { action, computed, makeObservable, observable } from 'mobx';
import { FlashAlert, errorAlert } from '../../../../../Notifications/Types';
import ParticipantsStore from '../../../../../ParticipantsStore';
import { TPlainTextKey } from '../../../../../Translations';
import { error } from '../../../../../ErrorHandling';

class ReclaimLicensesStore {
  readonly participantsStore: ParticipantsStore;

  @observable
  state: State;

  constructor(participantsStore: ParticipantsStore) {
    makeObservable(this);
    this.participantsStore = participantsStore;
    this.state = ready();
  }

  @action
  update = () => {
    switch (this.state.kind) {
      case 'ready':
      case 'error':
        this.state = updating();
        break;
      case 'updating':
      case 'succeeded':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (message: TPlainTextKey) => {
    switch (this.state.kind) {
      case 'updating':
        this.state = error(message);
        break;
      case 'ready':
      case 'succeeded':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  succeeded = (bulkLicensesReclaimedResource: BulkLicensesReclaimedResource) => {
    switch (this.state.kind) {
      case 'updating':
        let { payload } = bulkLicensesReclaimedResource;
        this.state = succeeded(payload.userCount, payload.reclaimedLicenseCount);
        break;
      case 'ready':
      case 'succeeded':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  ready = () => {
    this.state = ready();
  };

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'ready':
      case 'updating':
      case 'succeeded':
        return nothing();
      case 'error':
        return just(this.state).map(errorAlert);
    }
  }
}

export default ReclaimLicensesStore;
